import { FC } from "react";
import { ConversionInputs } from "src/components";
import { ConversionCard, PointsAmount } from "../../components";
import { Form, Skeleton } from "antd";
import { ProgramExchangeDetailsType } from "src/Modules/PointsExchange/constants";
import { getPointsAfterConversion } from "../../utils";
import { useTranslation } from "react-i18next";
import { Rule } from "antd/es/form";
import { formatNumber } from "src/utility";

const ExchangeMain: FC<Pick<ProgramExchangeDetailsType, "destinationProgram"|"exchangeInfo"|"points"|"loading">> = ({ loading, exchangeInfo, destinationProgram, points }) => {
  const { t } = useTranslation();
  const { sentValue } = getPointsAfterConversion(points ?? 0, exchangeInfo?.conversionRate ?? 1, exchangeInfo?.fees ?? 0);
  const pointsRules: Rule[] = [
    {
      validator: (_, value) => {
        const { sentValue: converted } = getPointsAfterConversion(value ?? 0, exchangeInfo.conversionRate, exchangeInfo.fees);
        if (converted < exchangeInfo.min) return Promise.reject(t("PointsExchange.exchange.minPointsError", { value: formatNumber(exchangeInfo.min) }));
        if (converted > exchangeInfo.max) return Promise.reject(t("PointsExchange.exchange.maxPointsError", { value: formatNumber(exchangeInfo.max) }));
        //if (value > totalPoints) return Promise.reject(t("PointsExchange.exchange.insufficientPointsError"));
        return Promise.resolve();
      },
    },
  ];
  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-0.5">
        <div className="text-font-default text-sm font-semibold">{t("PointsExchange.exchange.enterValue")}</div>
        <div className="text-font-subtle text-xs">{t("PointsExchange.exchange.enterValueSubtitle")}</div>
      </div>
      <ConversionInputs
        fromLabel={t("PointsExchange.exchange.pointsSuffix")}
        toLabel={destinationProgram?.unitLabel ?? t("PointsExchange.exchange.destinationPoints")}
        fromInput={
          <Skeleton active paragraph={{ rows: 1, width: "100%" }} title={false} loading={loading} className="flex-1! w-full!">
            <Form.Item
              name="points"
              rules={pointsRules}
              className="m-0! w-full! [&_.ant-col.ant-form-item-control]:flex! [&_.ant-col.ant-form-item-control]:flex-col! [&_.ant-col.ant-form-item-control]:items-stretch! [&_.ant-col.ant-form-item-control]:justify-end!"
            >
              <PointsAmount className="w-full!" />
            </Form.Item>
          </Skeleton>
        }
        toInput={<PointsAmount value={sentValue} disabled className={"w-full! flex-1"} unitLabel={destinationProgram?.unitLabel} />}
      />
      <ConversionCard exchangeInfo={exchangeInfo} isLoading={loading} />
    </div>
  );
};

export default ExchangeMain;
